import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
    Box,
    Typography,
    TextField,
    InputAdornment,
    IconButton,
    Grid,
    Card,
    CardContent,
    CardMedia,
    Chip,
    CircularProgress,
    Alert,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Pagination,
    Stack,
    Autocomplete,
    Button,
} from '@mui/material'

import SearchIcon from '@mui/icons-material/Search'
import RefreshIcon from '@mui/icons-material/Refresh'
import FilterListIcon from '@mui/icons-material/FilterList'
import { shopModel } from '../Axios/AxiosConfig'
import { productCache } from '../utils/productCache'
import { getInventoryState, saveInventoryState, clearInventoryState } from '../utils/persistentState'

interface Product {
    detaildesc: string;
    images?: ({ src?: string } | string)[];
    disease: string;
    company_id: string;
    onsale: boolean;
    product_image_url: string;
    type: string;
    orgprice: string;
    producttype: string;
    imgurl: string;
    variant_id: number;
    subtype: string;
    price: string;
    product_id: string;
    qty: string;
    name: string;
    deliverycharges: number;
    company: string;
    sku: string;
    desc: string;
    id: string;
}

const InventoryPage: React.FC = () => {
    const navigate = useNavigate()

    // Initialize state from persistence if available
    const savedState = getInventoryState()

    const [products, setProducts] = useState<Product[]>([])
    const [page, setPage] = useState(savedState?.page || 1)
    const [limit, setLimit] = useState(savedState?.limit || 6)
    const [total, setTotal] = useState(0)
    const [searchInput, setSearchInput] = useState(savedState?.searchInput || '')
    const [searchTerm, setSearchTerm] = useState(savedState?.searchTerm || '')
    const [searchSuggestions, setSearchSuggestions] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    // Filter states
    const [productType, setProductType] = useState(savedState?.productType || 'All')
    const [category, setCategory] = useState(savedState?.category || '')
    const [companyId, setCompanyId] = useState(savedState?.companyId || '')
    const [showFilters, setShowFilters] = useState(savedState?.showFilters || false)

    const totalPages = Math.max(1, Math.ceil(total / limit))

    const COMPANY_OPTIONS = [
        { id: '1002', name: 'Indus Biotech', email: 'ayurai@indusbiotech.com' },
        { id: '1003', name: 'BugSpeaks', email: 'hello@bugspeaks.com' },
        { id: '1005', name: 'Maharishi Ayurveda', email: 'info@maharishiayurvedaindia.com' },
        { id: '1007', name: 'Organic Wellness', email: 'ow@organicwellness.com' },
        { id: '1008', name: 'Microbiome', email: 'info@microbiome.in' },
        { id: '1010', name: 'Trudiagno Chembur Lab', email: 'Chemburlab@trudiagno.com' },
        { id: '1014', name: 'Potion1st', email: "info @potion1st.com" }
    ];


    const Categories = [
        { name: "All", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/all_product_icon.png", type: "All" },
        { name: "Tablets", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tablets.png", type: "Tablets" },
        { name: "Powders", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Powders.png", type: "Churna" },
        { name: "Oils", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Oils.png", type: "Oil" },
        { name: "Ghee", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Ghee.png", type: "Ghee" },
        { name: "Decoctions", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Decoctions.png", type: "Kashayam (Decoctions)" },
        { name: "Fermented", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Fermented.png", type: "Arishta" },
        { name: "Miscellaneous", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Miscellaneous.png", type: "Miscellaneous" },
        { name: "Syrups", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Syrups.png", type: "Syrup" },
        { name: "Tea", img: "https://aiwellassets.s3.ap-south-1.amazonaws.com/types+of+products/Tea.png", type: "Tea" }
    ];

    const allWellnessCategories = [
        {
            name: "Respiratory",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Respiratoty.png",
            selected: false
        },
        {
            name: "Mental",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Mental.png",
            selected: false
        },
        {
            name: "Gastro",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Gastro.png",
            selected: false
        },
        {
            name: "Hair & Skin",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Hair+%26amp%3B+Skin.png",
            selected: false
        },
        {
            name: "Physical",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Physical.png",
            selected: false
        },
        {
            name: "Women",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Women.png",
            selected: false
        },
        {
            name: "Sexual",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Sexual.png",
            selected: false
        },
        {
            name: "Metabolic",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/Metabolic.png",
            selected: false
        },
        {

            name: "General",
            imageUrl: "https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/General_wellness.png",
            selected: false
        }
    ];

    const fetchProducts = async (bypassCache = false) => {
        try {
            setLoading(true)
            setError(null)

            // Build filter parameters
            const filterParams: any = {
                page,
                limit,
            }

            if (searchTerm.trim()) {
                filterParams.search = searchTerm.trim()
            }

            // Check cache first (only if not bypassing cache and no search)
            if (!bypassCache && !searchTerm.trim()) {
                const cachedData = productCache.get<{ products: Product[]; total: number }>(
                    { type: productType, category, companyId, page, limit }
                )

                if (cachedData) {
                    console.log('Using cached data for filters:', { productType, category, companyId })
                    setProducts(cachedData.products)
                    setTotal(cachedData.total)
                    setLoading(false)
                    return
                }
            }

            // Determine which endpoint to use
            let response: any

            // If filters are applied, use the filter endpoint
            if ((productType && productType !== 'All') || category || companyId) {
                const filterBody: any = {
                    type: productType,
                    category: category || '',
                    companyId: companyId || '',
                }

                console.log('Fetching filtered products:', filterBody)
                response = await shopModel.post('/getProductbytype', filterBody)

                // For filtered results, implement client-side pagination
                const allData = Array.isArray(response?.data) ? response.data : []
                const startIndex = (page - 1) * limit
                const endIndex = startIndex + limit
                const paginatedData = allData.slice(startIndex, endIndex)

                setProducts(paginatedData)
                setTotal(allData.length)

                // Cache the full filtered results
                productCache.set(
                    { type: productType, category, companyId, page, limit },
                    { products: paginatedData, total: allData.length },
                    5 * 60 * 1000 // 5 minutes TTL
                )
            } else {
                // Use regular inventory endpoint for unfiltered or search queries
                response = await shopModel.get('/ExploreIventory', { params: filterParams })

                const { totalCount, data }: any = response?.data

                let items: any[] = []

                if (Array.isArray(data)) {
                    items = data
                } else if (Array.isArray(data?.products)) {
                    items = data.products
                } else if (Array.isArray(data?.items)) {
                    items = data.items
                } else if (Array.isArray(data?.data)) {
                    items = data.data
                }

                setProducts(items)
                setTotal(totalCount)

                // Cache unfiltered results (only if not searching)
                if (!searchTerm.trim()) {
                    productCache.set(
                        { type: productType, category, companyId, page, limit },
                        { products: items, total: totalCount },
                        5 * 60 * 1000 // 5 minutes TTL
                    )
                }
            }

        } catch (err: any) {
            console.error('Error fetching inventory:', err)
            setError(err?.response?.data?.message || 'Failed to load inventory')
        } finally {
            setLoading(false)
        }
    }

    const fetchSearchSuggestions = async (query: string) => {
        if (!query.trim()) {
            setSearchSuggestions([])
            return
        }

        try {
            const response = await shopModel.post('/SearchProducts', { search: query.trim() })
            const data: any[] = Array.isArray(response?.data) ? response.data : []
            setSearchSuggestions(data)
        } catch (err) {
            console.error('Error fetching search suggestions:', err)
            setSearchSuggestions([])
        }
    }

    useEffect(() => {
        fetchProducts()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit, searchTerm, productType, category, companyId])

    // Save state to persistence when it changes
    useEffect(() => {
        saveInventoryState({
            page,
            limit,
            productType,
            category,
            companyId,
            showFilters,
            searchTerm,
            searchInput,
        })
    }, [page, limit, productType, category, companyId, showFilters, searchTerm, searchInput])

    const handleClearSearch = () => {
        setSearchInput('')
        setSearchTerm('')
        setSearchSuggestions([])
        setPage(1)
    }

    const handleClearFilters = () => {
        setProductType('All')
        setCategory('')
        setCompanyId('')
        setPage(1)
        productCache.clearAll()
        clearInventoryState()
    }

    const handlePageSizeChange = (event: any) => {
        const newLimit = parseInt(event.target.value, 10)
        if (!Number.isNaN(newLimit)) {
            setLimit(newLimit)
            setPage(1)
        }
    }

    const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setPage(value)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleRefresh = () => {
        productCache.clearAll()
        fetchProducts(true) // Bypass cache
    }

    return (
        <Box sx={{ p: 3, pt: 1.5, minHeight: '100vh' }}>
            <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                <Box>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 600, fontFamily: 'Libre Baskerville', color: '#3B362A' }}>
                        Inventory
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary">
                        Manage and view all product details
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate('/inventory/add')}
                    sx={{ textTransform: 'none', borderRadius: 2 }}
                >
                    Add Product
                </Button>
            </Box>

            <Box
                sx={{
                    mb: 3,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    alignItems: 'center',
                }}
            >
                <Autocomplete
                    freeSolo
                    options={searchSuggestions.length > 0 ? searchSuggestions : products}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') return option
                        const anyOption: any = option
                        return anyOption?.name || ''
                    }}
                    inputValue={searchInput}
                    onInputChange={(_, newInputValue) => {
                        setSearchInput(newInputValue)
                        setPage(1)
                        setSearchTerm(newInputValue.trim())
                        if (newInputValue.trim().length >= 2) {
                            fetchSearchSuggestions(newInputValue)
                        } else {
                            setSearchSuggestions([])
                        }
                    }}
                    onChange={(_, newValue) => {
                        if (newValue && typeof newValue !== 'string') {
                            const selected: any = newValue
                            if (selected.id) {
                                navigate(`/inventory/${selected.id}`)
                            }
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            size="small"
                            placeholder="Search products..."
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )}
                    sx={{ flex: 1, minWidth: 220, maxWidth: 400 }}
                />

                <Stack direction="row" spacing={1} alignItems="center">
                    {searchTerm && (
                        <IconButton
                            onClick={handleClearSearch}
                            disabled={loading}
                            sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
                        >
                            <RefreshIcon fontSize="small" />
                        </IconButton>
                    )}
                    <IconButton
                        onClick={handleRefresh}
                        disabled={loading}
                        sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
                    >
                        <RefreshIcon fontSize="small" />
                    </IconButton>
                </Stack>

                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="inventory-page-size-label">Per page</InputLabel>
                    <Select
                        labelId="inventory-page-size-label"
                        value={String(limit)}
                        label="Per page"
                        onChange={handlePageSizeChange}
                    >
                        <MenuItem value="6">6</MenuItem>
                        <MenuItem value="12">12</MenuItem>
                        <MenuItem value="24">24</MenuItem>
                    </Select>
                </FormControl>

                <IconButton
                    onClick={() => setShowFilters(!showFilters)}
                    sx={{
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: showFilters ? 'primary.main' : 'divider',
                        bgcolor: showFilters ? 'primary.light' : 'transparent',
                        color: showFilters ? 'primary.main' : 'inherit'
                    }}
                    title="Toggle Filters"
                >
                    <FilterListIcon fontSize="small" />
                </IconButton>
            </Box>

            {/* Filter Section */}
            {showFilters && (
                <Box
                    sx={{
                        mb: 3,
                        p: 2,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            Filter Products
                        </Typography>
                        <Button
                            size="small"
                            onClick={handleClearFilters}
                            sx={{ textTransform: 'none' }}
                        >
                            Clear All Filters
                        </Button>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="ProductType-label">Product Type</InputLabel>
                                <Select
                                    fullWidth
                                    size="small"
                                    label="Product Type"
                                    value={productType}
                                    onChange={(e) => {
                                        setProductType(e.target.value)
                                        setPage(1)
                                    }}



                                >

                                    {
                                        Categories.map((option) => (
                                            <MenuItem value={option.name}>
                                                <div className='flex gap-2 items-center'>
                                                    <div>
                                                        <img src={option?.img} alt="" className="w-10 h-10" />
                                                    </div>
                                                    <div className="flex flex-col">
                                                        {option?.name}
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        ))

                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="category-label">Category</InputLabel>
                                <Select
                                    fullWidth
                                    size="small"
                                    label="Category"
                                    value={category}
                                    onChange={(e) => {
                                        setCategory(e.target.value)
                                        setPage(1)
                                    }}



                                >

                                    {
                                        allWellnessCategories.map((option) => (
                                            <MenuItem value={option.name}>
                                                <div className='flex gap-2 items-center'>
                                                    <div>
                                                        <img src={option.imageUrl} alt="" className="w-10 h-10" />
                                                    </div>
                                                    <div className="flex flex-col">
                                                        {option.name}
                                                    </div>
                                                </div>
                                            </MenuItem>
                                        ))

                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="company-id-label">Company ID</InputLabel>
                                <Select
                                    labelId="company-id-label"
                                    value={companyId}
                                    label="Company ID"
                                    onChange={(e) => {
                                        setCompanyId(e.target.value)
                                        setPage(1)
                                    }}>
                                    {COMPANY_OPTIONS.map((option) => (
                                        <MenuItem key={option.id} value={option.name}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                        </Grid>
                    </Grid>

                    {(productType !== 'All' || category || companyId) && (
                        <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                                Active Filters:
                            </Typography>
                            {productType !== 'All' && (
                                <Chip
                                    label={`Type: ${productType}`}
                                    size="small"
                                    onDelete={() => {
                                        setProductType('All')
                                        setPage(1)
                                    }}
                                />
                            )}
                            {category && (
                                <Chip
                                    label={`Category: ${category}`}
                                    size="small"
                                    onDelete={() => {
                                        setCategory('')
                                        setPage(1)
                                    }}
                                />
                            )}
                            {companyId && (
                                <Chip
                                    label={`Company: ${companyId}`}
                                    size="small"
                                    onDelete={() => {
                                        setCompanyId('')
                                        setPage(1)
                                    }}
                                />
                            )}
                        </Box>
                    )}
                </Box>
            )}

            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}

            <Box sx={{ position: 'relative' }}>
                {loading && (
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            bgcolor: 'rgba(255,255,255,0.6)',
                            zIndex: 1,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                )}

                {products.length === 0 && !loading ? (
                    <Box sx={{ py: 8, textAlign: 'center', color: 'text.secondary' }}>
                        <Typography variant="subtitle1">No products found</Typography>
                        <Typography variant="body2">Try adjusting your search or filters.</Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2}>
                        {products.map((product) => {
                            const key = product.id;

                            const imagesArray = Array.isArray(product.images) ? product.images : [];
                            const firstImageFromArray =
                                imagesArray.length > 0
                                    ? (typeof imagesArray[0] === 'string'
                                        ? imagesArray[0]
                                        : (imagesArray[0] as any)?.src)
                                    : undefined;

                            const image = product.imgurl || product.product_image_url || firstImageFromArray;

                            const name = product.name;
                            const company = product.company;
                            const price = product.price;
                            const stock = product.onsale;

                            return (
                                <Grid item key={key} xs={12} sm={6} md={4} lg={3}>
                                    <Card
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            borderRadius: 3,
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                            overflow: 'hidden',
                                            transition: 'all 0.25s ease',
                                            '&:hover': {
                                                transform: 'translateY(-4px)',
                                                boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
                                            },
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => navigate(`/inventory/${product.id}`)}
                                    >

                                        {/* IMAGE SECTION */}
                                        {image ? (
                                            <Box
                                                sx={{
                                                    height: 180,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    background: 'linear-gradient(45deg, #f4ecd6 30%, #f8f8f4 90%)',
                                                    p: 2,
                                                }}
                                            >
                                                <CardMedia
                                                    component="img"
                                                    image={image}
                                                    alt={name}
                                                    sx={{
                                                        height: '100%',
                                                        width: 'auto',
                                                        objectFit: 'contain',
                                                        mixBlendMode: 'multiply',
                                                        borderRadius: 2,
                                                        transition: 'transform 0.3s ease',
                                                        '&:hover': {
                                                            transform: 'scale(1.05)',
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        ) : (
                                            <Box
                                                sx={{
                                                    height: 180,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    background: 'linear-gradient(45deg, #f4ecd6 30%, #f8f8f4 90%)',
                                                }}
                                            >
                                                <Typography variant="subtitle2" color="text.secondary">
                                                    No image
                                                </Typography>
                                            </Box>
                                        )}

                                        {/* CONTENT SECTION */}
                                        <CardContent
                                            sx={{
                                                flexGrow: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1,
                                                px: 2.2,
                                                pt: 2,
                                                pb: 2.5,
                                            }}
                                        >
                                            <Typography
                                                variant="subtitle1"
                                                sx={{
                                                    fontWeight: 700,
                                                    letterSpacing: 0.1,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                                title={name}
                                            >
                                                {name}
                                            </Typography>

                                            {company && (
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                    title={company}
                                                >
                                                    {company}
                                                </Typography>
                                            )}

                                            {/* PRICE + STOCK */}
                                            <Box
                                                sx={{
                                                    mt: 1.5,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {price !== undefined && (
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            fontWeight: 700,
                                                            color: '#4a4a4a',
                                                        }}
                                                    >
                                                        ₹{price}
                                                    </Typography>
                                                )}

                                                {/* Modern Stock Badge */}
                                                {stock && (
                                                    <Chip
                                                        label="In Stock"
                                                        size="small"
                                                        color="success"
                                                        sx={{
                                                            fontSize: 12,
                                                            px: 1,
                                                            py: 0.5,
                                                            borderRadius: 1,
                                                            fontWeight: 600,
                                                            backgroundColor: 'rgba(56,142,60,0.15)',
                                                            color: '#1b5e20',
                                                        }}
                                                    />
                                                )}

                                                {!stock && (
                                                    <Chip
                                                        label="Out of Stock"
                                                        size="small"
                                                        color="error"
                                                        sx={{
                                                            fontSize: 12,
                                                            px: 1,
                                                            py: 0.5,
                                                            borderRadius: 1,
                                                            fontWeight: 600,
                                                            backgroundColor: 'rgba(244,67,54,0.15)',
                                                            color: '#b71c1c',
                                                        }}
                                                    />
                                                )}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            );
                        })}
                    </Grid>

                )}
            </Box>

            {products.length > 0 && (
                <Box
                    sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        Showing {(page - 1) * limit + 1}-{Math.min(page * limit, total)} of {total} products
                    </Typography>
                    <Pagination
                        size="large"
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    )
}

export default InventoryPage